import React, { useEffect, useState } from "react";
import "./HotelModifyNew.css";
import { FaChevronLeft, FaCity } from "react-icons/fa";
import { IoPerson } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import moment from "moment";
import SearchFormMobile from "../../Hotel/HotelSearch/HotelSearchMobile/SearchFormMobile";
import axios from "axios";
import { Col, Row, Spinner } from "react-bootstrap";
import { DayPickerRangeController } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

const HotelModifyForm = () => {
  const handleShowSearchForm = () => {
    setShowSearchFormMobile(true);
  };

  const handleHideSearchForm = () => {
    setShowSearchFormMobile(false);
  };

  const [showSearchFormMobile, setShowSearchFormMobile] = useState(false);
  const [labelClicked, setLabelClicked] = useState(false);
  const [rooms, setRooms] = useState([
    { adults: 2, children: 0, childrenAges: [] },
  ]);
  const [totalGuests, setTotalGuests] = useState(2);
  const location = useLocation();
  const navigate = useNavigate();

  // Date picker states
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [calVisible, setCalVisible] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from") || "";
  const city = queryParams.get("city");
  const startDateRaw = queryParams.get("startDate");
  const endDateRaw = queryParams.get("endDate");

  // Initialize dates from URL params
  useEffect(() => {
    if (startDateRaw) {
      setStartDate(moment(startDateRaw));
    }
    if (endDateRaw) {
      setEndDate(moment(endDateRaw));
    }
  }, [startDateRaw, endDateRaw]);

  const [fromInput, setFromInput] = useState(from);
  const [startDateInput, setStartDateInput] = useState(
    startDateRaw ? moment(startDateRaw).format("YYYY-MM-DD") : ""
  );
  const [endDateInput, setEndDateInput] = useState(
    endDateRaw ? moment(endDateRaw).format("YYYY-MM-DD") : ""
  );

  useEffect(() => {
    const roomsRaw = queryParams.get("rooms");
    if (roomsRaw) {
      try {
        const parsed = JSON.parse(roomsRaw);
        setRooms(parsed);
        const guests = parsed.reduce(
          (sum, r) => sum + (r.adults || 0) + (r.children || 0),
          0
        );
        setTotalGuests(guests);
      } catch (err) {
        console.error("Invalid rooms JSON", err);
      }
    }
  }, [location.search]);

  const updateRoom = (index, type, value) => {
    const newRooms = [...rooms];
    newRooms[index][type] = value;
    if (type === "children") {
      newRooms[index].childrenAges = Array(value).fill("");
    }
    setRooms(newRooms);
    setTotalGuests(newRooms.reduce((sum, r) => sum + r.adults + r.children, 0));
  };

  const updateChildAge = (roomIndex, childIndex, value) => {
    const newRooms = [...rooms];
    newRooms[roomIndex].childrenAges[childIndex] = value;
    setRooms(newRooms);
  };

  const addRoom = () => {
    setRooms([...rooms, { adults: 2, children: 0, childrenAges: [] }]);
  };

  const removeRoom = (index) => {
    const newRooms = rooms.filter((_, i) => i !== index);
    setRooms(newRooms);
    setTotalGuests(newRooms.reduce((sum, r) => sum + r.adults + r.children, 0));
  };

  // Date picker handlers
  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if (startDate) {
      setStartDateInput(startDate.format("YYYY-MM-DD"));
    }
    if (endDate) {
      setEndDateInput(endDate.format("YYYY-MM-DD"));
    }
  };

  const toggleCalendar = (input) => {
    setFocusedInput(input);
    setCalVisible(!calVisible);
  };

  const handleSearch = () => {
    const query = new URLSearchParams({
      from: selectedCityId,
      startDate: startDateInput,
      endDate: endDateInput,
      rooms: JSON.stringify(rooms),
    }).toString();

    localStorage.setItem("hotelRoomsConfig", JSON.stringify(rooms));
    navigate(`/hotelmodify?${query}`);
  };

  const formattedFrom = from
    .split(",")
    .map((s) => s.trim())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(", ");

  const handleDone = () => {
    setLabelClicked(false);
  };

  // Search input states and handlers
  const [searchInput, setSearchInput] = useState(city);
  const [isItemSelected, setIsItemSelected] = useState(true);
  const [cities2, setCities2] = useState([]);
  const [destinationCity, setDestinationCity] = useState("New Delhi");
  const [selectedCityId, setSelectedCityId] = useState(130443);
  const [destination1, setDestination1] = useState({
    id: 130443,
    CityName: "New Delhi",
    CountryName: "India",
    CountryCode: "IN",
    isTopCity: true,
    category: "domestic",
  });
  const [searchedHotel, setSearchedHotel] = useState("New Delhi");
  const [selectedCityName, setSelectedCityName] = useState("New Delhi");
  const [clickDestination, SetClickDestination] = useState(false);

  const handleInputChange = (value) => {
    setSearchInput(value);
    SetClickDestination(true);
    setIsItemSelected(false);

    if (value.length === 0) {
      setCities2([]);
    } else if (value.length >= 3) {
      fetchDatas(value.toLowerCase());
    } else {
      setCities2([]);
    }
  };

  const handleCitySelect = (city) => {
    setDestinationCity(`${city["CityName"]}`);
    setSelectedCityId(`${city["DestinationId"]}`);
    setSelectedCityName(city["CityName"]);
    setSearchedHotel(`${city["CityName"]}`);
    SetClickDestination(false);
    setSearchInput(`${city["CityName"]} (${city["CountryName"]})`);
    setIsItemSelected(true);
    setDestination1(city);
  };

  const handleInputFocus = () => {
    setSearchInput("");
    setSearchedHotel("");
    SetClickDestination(true);
    setCities2([]);
  };

  const handleInputBlur = () => {
    if (!isItemSelected && searchInput === "") {
      setSearchInput("New Delhi (India)");
    }
  };

  const fetchDatas = async (value) => {
    try {
      const requestData = {
        city: value,
      };

      const response = await axios.post(
        "https://admin.travelsdata.com/api/Hotel/CityList",
        requestData
      );

      const json = response.data;
      // console.log("json responseee", json);

      const results = json.data
        .filter((user) => {
          return (
            user &&
            ((user.CityName &&
              user.CityName.toLowerCase().includes(value.toLowerCase())) ||
              (user.CountryName &&
                user.CountryName.toLowerCase().includes(value.toLowerCase())))
          );
        })
        .map((user) => {
          let priority = 3;

          if (
            user.CityName &&
            user.CityName.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 1;
          } else if (
            user.CountryName &&
            user.CountryName.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 2;
          }

          return { ...user, priority };
        })
        .sort((a, b) => a.priority - b.priority);

      // console.log("RESULTS", results);
      setCities2(results);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="hotelmodifysearch-Main">
      <div className="hotelmodifysearch">
        <img
          src="Images/flight_aero.png"
          alt=""
          style={{ width: "40px", marginRight: "10px" }}
        />

        <div className="hotelmodifysearchinputs" style={{ width: "30%" }}>
          <label className="hotelmodifylabelstyling">
            City name, Location or Specific hotel
          </label>
          <input
            type="text"
            className="hotelmodifyinputstyling"
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            value={searchInput}
            onChange={(e) => handleInputChange(e.target.value)}
            placeholder="Enter city or hotel name"
          />
          <div style={{ position: "relative" }}>
            <div
              className="cityselect"
              style={{
                position: "absolute",
                color: "black",
                backgroundColor: "white",
                padding: "10px",
                border: "1px solid #e3e3e3",
                display: clickDestination ? "block" : "none",
                width: "100%",
                zIndex: 9,
                top: "5px",
                maxHeight: 300,
                borderRadius: "5px",
                overflow: "auto",
                scrollbarWidth: "thin",
                background: "#fff",
                boxShadow: "0 0 3px rgb(0 0 0 / 30%)",
              }}
            >
              {cities2.length !== 0 ? (
                <>
                  {cities2
                    .filter((city) => !city.isTopCity)
                    .map((city, index) => (
                      <div
                        key={index}
                        style={{
                          borderBottom: "1px solid grey",
                          paddingBottom: 5,
                          marginBottom: 5,
                          cursor: "pointer",
                          backgroundColor: "white",
                        }}
                        onClick={() => handleCitySelect(city)}
                      >
                        <Row>
                          <Col md={1} style={{ alignItems: "center" }}>
                            <FaCity
                              size={22}
                              style={{
                                textAlign: "center",
                                height: "100%",
                                color: "#2d3290",
                              }}
                            />
                          </Col>
                          <Col md={11}>
                            <Row>
                              <div
                                className="flightFromName"
                                style={{
                                  color: "#2d3290",
                                  fontWeight: 600,
                                }}
                              >
                                {city.CityName}
                              </div>
                            </Row>
                            <Row style={{ color: "grey" }}>
                              <Col md={10} style={{ paddingRight: 0 }}>
                                <div
                                  className="flightFromNameInner"
                                  style={{
                                    fontSize: 10,
                                    fontWeight: 600,
                                  }}
                                >
                                  {city.CountryName}
                                </div>
                              </Col>
                              <Col md={2} style={{ paddingLeft: 0 }}>
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "700",
                                    fontSize: 10,
                                  }}
                                >
                                  {city.CountryCode}
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    ))}
                </>
              ) : (
                <div
                  style={{
                    padding: "10px 5px",
                    fontSize: "12px",
                    textAlign: "center",
                    margin: "auto",
                    width: "100%",
                  }}
                >
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Please wait we are fetching city list...
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="hotelmodifysearchinputs"
          style={{ width: "15%", position: "relative" }}
        >
          <label className="hotelmodifylabelstyling">Check-In</label>
          <input
            type="text"
            className="hotelmodifyinputstyling"
            value={startDate ? startDate.format("MM/DD/YYYY") : ""}
            onClick={() => toggleCalendar("startDate")}
            readOnly
            placeholder="Select date"
          />
          {calVisible && focusedInput === "startDate" && (
            <div
              style={{
                position: "absolute",
                zIndex: "2000",
                top: "100%",
                left: 0,
              }}
            >
              <DayPickerRangeController
                startDate={startDate}
                endDate={endDate}
                onDatesChange={handleDatesChange}
                focusedInput={focusedInput}
                onFocusChange={(focused) => setFocusedInput(focused)}
                isOutsideRange={(day) => day.isBefore(moment(), "day")}
                numberOfMonths={2}
                daySize={32}
              />
            </div>
          )}
        </div>

        <div
          className="hotelmodifysearchinputs"
          style={{ width: "15%", position: "relative" }}
        >
          <label className="hotelmodifylabelstyling">Check-Out</label>
          <input
            type="text"
            className="hotelmodifyinputstyling"
            value={endDate ? endDate.format("MM/DD/YYYY") : ""}
            onClick={() => toggleCalendar("endDate")}
            readOnly
            placeholder="Select date"
          />
          {calVisible && focusedInput === "endDate" && (
            <div
              style={{
                position: "absolute",
                zIndex: "2000",
                top: "100%",
                left: 0,
              }}
            >
              <DayPickerRangeController
                startDate={startDate}
                endDate={endDate}
                onDatesChange={handleDatesChange}
                focusedInput={focusedInput}
                onFocusChange={(focused) => setFocusedInput(focused)}
                isOutsideRange={(day) => day.isBefore(moment(), "day")}
                numberOfMonths={2}
                daySize={32}
              />
            </div>
          )}
        </div>

        <div
          className="hotelmodifysearchinputs"
          style={{ width: "15%", position: "relative" }}
        >
          <label className="hotelmodifylabelstyling">Rooms & Guests</label>
          <input
            type="text"
            className="hotelmodifyinputstyling"
            value={`${totalGuests} Guests, ${rooms.length} Room${
              rooms.length !== 1 ? "s" : ""
            }`}
            onClick={() => setLabelClicked(!labelClicked)}
            readOnly
          />

          {labelClicked && (
            <div
              className="onlytraveller normaltraveller"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                zIndex: 999,
                color: "black",
              }}
            >
              <ul className="traveller_list">
                <li>
                  <div
                    className="list-persons-count"
                    style={{ marginBottom: "8px" }}
                  >
                    <ul className="traveller_list">
                      {rooms.map((room, index) => (
                        <li key={index}>
                          <div className="list-persons-count">
                            <div id="roomshtml">
                              <div className="box">
                                <div className="roomTxt">
                                  <span>Room </span>
                                  {index + 1}:
                                </div>

                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <div className="txt">
                                      <span id="Label7">Adults</span>
                                      <div style={{ fontSize: "10px" }}>
                                        <em>(12+ years)</em>
                                      </div>
                                    </div>
                                    <div className="right pull-right">
                                      <div
                                        id="field1"
                                        className="right PlusMinusRow"
                                      >
                                        <button
                                          type="button"
                                          style={{ border: "none" }}
                                          id="Adults_room_1_1_minus"
                                          className="sub hoteladultclass"
                                          onClick={() =>
                                            updateRoom(
                                              index,
                                              "adults",
                                              Math.max(room.adults - 1, 1)
                                            )
                                          }
                                        >
                                          -
                                        </button>
                                        <span
                                          id="Adults_room_1_1"
                                          className="PlusMinus_number"
                                        >
                                          {room.adults}
                                        </span>
                                        <button
                                          type="button"
                                          style={{ border: "none" }}
                                          id="Adults_room_1_1_plus"
                                          className="add hoteladultclass"
                                          onClick={() =>
                                            updateRoom(
                                              index,
                                              "adults",
                                              Math.min(room.adults + 1, 6)
                                            )
                                          }
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="hotel_childStyling">
                                  <div className="hotel_childStyling_txt">
                                    <span id="Label9">Child</span>
                                    <div style={{ fontSize: "10px" }}>
                                      <em>(2–12 years)</em>
                                    </div>
                                  </div>
                                  <div className="right">
                                    <div
                                      id="field2"
                                      className="right PlusMinusRow"
                                    >
                                      <button
                                        style={{ border: "none" }}
                                        type="button"
                                        id="Children_room_1_1_minus"
                                        className="sub hotelchildclass"
                                        onClick={() =>
                                          updateRoom(
                                            index,
                                            "children",
                                            Math.max(room.children - 1, 0)
                                          )
                                        }
                                      >
                                        -
                                      </button>
                                      <span
                                        id="Children_room_1_1"
                                        className="PlusMinus_number"
                                      >
                                        {room.children}
                                      </span>
                                      <button
                                        style={{ border: "none" }}
                                        type="button"
                                        id="Children_room_1_1_plus"
                                        className="add hotelchildclassss"
                                        onClick={() =>
                                          updateRoom(
                                            index,
                                            "children",
                                            Math.min(room.children + 1, 6)
                                          )
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                {room.children > 0 && (
                                  <div>
                                    Age(s) of Children
                                    {room.childrenAges.map(
                                      (age, childIndex) => (
                                        <select
                                          key={childIndex}
                                          value={age || ""}
                                          onChange={(e) =>
                                            updateChildAge(
                                              index,
                                              childIndex,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Age</option>
                                          {[...Array(12)].map((_, i) => (
                                            <option key={i} value={i + 1}>
                                              {i + 1}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                            {index === rooms.length - 1 && (
                              <div
                                id="addhotelRoom"
                                className="cus_add_remove_btn addroom"
                                onClick={addRoom}
                              >
                                Add Room
                              </div>
                            )}
                            {rooms.length > 1 && (
                              <div
                                id="removehotelRoom"
                                className="cus_add_remove_btn removeroom"
                                onClick={() => removeRoom(index)}
                              >
                                Remove Room
                              </div>
                            )}
                          </div>
                        </li>
                      ))}
                      <button
                        className="apply_btn hotel_modify_add_btn"
                        style={{ border: "none" }}
                        onClick={handleDone}
                      >
                        Done
                      </button>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>

        <div style={{ width: "15%" }}>
          <button className="hotelmodifysearch-btn" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>

      <div className="Hotel-reSearchForm">
        <Link to="/hotel" style={{ textDecoration: "none" }}>
          <div style={{ cursor: "pointer" }}>
            <span style={{ marginRight: "15px" }}>
              <FaChevronLeft style={{ fontSize: "14px", color: "white" }} />
            </span>
          </div>
        </Link>
        <div className="Hotel-reSearchFormStyling">
          <div className="Hotel-reSearchForm-InnerStyling">
            <div className="Hotel-reSearchForm-InnerdivStyling">
              {searchInput}
            </div>
            <div className="Hotel-reSearchForm-InnerdivStyling">
              {startDate ? startDate.format("MM/DD") : "--/--"}
              {endDate || endDateInput
                ? " - " +
                  (endDate
                    ? endDate.format("MM/DD")
                    : moment(endDateInput).format("MM/DD"))
                : ""}
            </div>
            <div
              className="Hotel-reSearchForm-InnerdivStyling"
              style={{ border: "none", display: "flex", alignItems: "center" }}
            >
              {totalGuests} <IoPerson />
            </div>
          </div>
          <div
            className="Hotel-reSearchForm-InnerdivStyling"
            style={{ border: "none" }}
            onClick={handleShowSearchForm}
          >
            CHANGE
          </div>
        </div>
      </div>

      {showSearchFormMobile && (
        <div className="HotelSearchForm-Mobile">
          <div
            className="HotelSearchForm-MobileIcon"
            onClick={handleHideSearchForm}
          >
            <RxCross2
              style={{
                borderRadius: "100px",
                background: "white",
                width: "35px",
                height: "35px",
                padding: "5px",
              }}
            />
          </div>
          <SearchFormMobile
            onSearchComplete={handleHideSearchForm}
            initialCityName={searchInput}
            initialCityId={selectedCityId}
            initialStartDate={
              startDateInput ||
              (startDate ? startDate.format("YYYY-MM-DD") : null)
            }
            initialEndDate={
              endDateInput || (endDate ? endDate.format("YYYY-MM-DD") : null)
            }
            initialRooms={rooms}
          />
        </div>
      )}
    </div>
  );
};

export default HotelModifyForm;
